export const getClickedLinkElement = event => {
    const $targetElement = $(event.target);

    return $targetElement.prop('tagName') !== 'A'
        ? $targetElement.parents('a')
        : $targetElement;
};
